import { fireCancelableEvent } from '../internal/events';
export var breadcrumbItemClickHandler = function (item, onFollow, onClick, event) {
    var specialKey = event && (event.button !== 0 || event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
    var eventDetail = {
        item: item,
        text: item.text,
        href: item.href
    };
    if (!specialKey) {
        fireCancelableEvent(onFollow, eventDetail, event);
    }
    fireCancelableEvent(onClick, eventDetail, event);
};
//# sourceMappingURL=item-click-handler.js.map